import React from 'react';
import { Badge } from '@chakra-ui/react';
import { STATUS_LABELS, STATUS_COLORS } from 'api/administrador/refunds';

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  const colors = STATUS_COLORS[status] || { bg: 'gray.100', color: 'gray.600', borderColor: 'gray.300' };

  return (
    <Badge
      px={3}
      py={1}
      borderRadius="full"
      fontSize="xs"
      fontWeight="bold"
      bg={colors.bg}
      color={colors.color}
      border="1px solid"
      borderColor={colors.borderColor}
      textTransform="uppercase"
    >
      {label}
    </Badge>
  );
}
